import { Field, Formik } from "formik";
import { Form, Button, Image, InputGroup } from "react-bootstrap";
import { isEmpty } from "lodash";
import React from "react";
import {
  FieldDropSide,
  FieldInput,
  FormControlSearch,
  MultiSelectDropdown,
  SearchableList,
} from "../../../components";
import {
  formFields,
  manageFeeFormNames,
  OPTIONS_DATA_MAPPER,
  toMultiSelectValueById,
  toOptionValuesFromMapper,
} from "../../../utils";

const allOption = { label: "All", value: null };
const SpecificationFilterCard = ({ filterData, setFilterData }) => {
  const formName = manageFeeFormNames.MANAGE_SPECIFICATION_INFORMATION;
  const fields = formFields[formName];

  const onFormSubmit = (values, { setFieldError }) => {
    setFilterData({
      ...filterData,
      searchString: values[fields.specificationName] || "",
      allocationType: values[fields.allocationType] || null,
      feeType: values[fields.feeType] || null,
      from: 0,
      to: 20,
      count: 0,
    });
  };

  const allOption = { label: "All", value: null };

  return (
    <Formik
      initialValues={{}}
      enableReinitialize
      onSubmit={onFormSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        setFieldError,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => {
        return (
          <Form
            autoComplete="off"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="d-flex align-item-center pad-50-right justify-content-between">
              <div className="d-flex">
                <div className="d-flex ml-1">
                  <label
                    className="fw-600 ft-14"
                    style={{ whiteSpace: "nowrap", color: "#919191" }}
                  >
                    Search Specification
                  </label>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <div
                        className="search-icon-postion"
                        style={{ marginLeft: "-137px", marginTop: "37px" }}
                      >
                        <i class="fas fa-search" aria-hidden="true"></i>
                      </div>
                    </InputGroup.Prepend>

                    <FormControlSearch
                      size="xs"
                      type="search"
                      style={{
                        borderRadius: "5px",
                        width: "15rem",
                        marginTop: "27px",
                        marginLeft: "-140px",
                        paddingLeft: "30px",
                      }}
                      placeholder="Search Specification name"
                      onChange={(e) =>
                        setFieldValue(fields.specificationName, e.target.value)
                      }
                    />
                  </InputGroup>
                </div>

                <label
                  className="fw-600 ft-14 ml-2"
                  style={{ color: "#919191" }}
                >
                  Fee Type
                </label>
                <div style={{ marginLeft: "-59px", marginTop: "27px" }}>
                  <Field
                    size="sm"
                    placeholder="All"
                    name={fields.feeType}
                    value={toMultiSelectValueById(
                      values[fields.feeType],
                      toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.FEES_TYPE)
                    )}
                    isMultiSelect
                    isRequired
                    direction="bottom"
                    popupContent={
                      <MultiSelectDropdown
                        label="Select Fee Type"
                        name={fields.feeType}
                        onSelect={(value) => {
                          setFieldValue(fields.feeType, value);
                        }}
                        value={values[fields.feeType]}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.FEES_TYPE
                        )}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>

                <label
                  className="fw-600 ft-14 ml-3"
                  style={{ color: "#919191" }}
                >
                  Allocation type
                </label>
                <div
                  style={{
                    marginTop: "27px",
                    marginLeft: "-99px",
                  }}
                >
                  <Field
                    size="sm"
                    placeholder="All"
                    name={fields.allocationType}
                    value={toMultiSelectValueById(
                      values[fields.allocationType],
                      toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.ALLOCATION_TYPE
                      )
                    )}
                    isMultiSelect
                    isRequired
                    direction="bottom"
                    popupContent={
                      <MultiSelectDropdown
                        label="Select Allocation Type"
                        name={fields.allocationType}
                        onSelect={(value) => {
                          setFieldValue(fields.allocationType, value);
                        }}
                        value={values[fields.allocationType]}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.ALLOCATION_TYPE
                        )}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div className="mr-5 mt-3">
                  <Button
                    className="ml-2 mt-12 sort-button"
                    style={{ lineHeight: "19px" }}
                    variant="secondary"
                    type="submit"
                  >
                    Search
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SpecificationFilterCard;
